import type PetsRaterAnswers from '@/modules/pets/rater/models/APP/PetsRaterAnswers'
import PetsRaterPriceRequest from '@/modules/pets/common/models/MID/requests/PetsRaterPriceRequest'
import CommonMapper from '@/modules/core/mappers/CommonMapper'

export default class GetPricingMapper {
  static toRequest(
    data: PetsRaterAnswers,
    isQuote: boolean = false,
    mediator?: string
  ): PetsRaterPriceRequest {
    let clientProducts
    if (data?.product) {
      clientProducts = [
        {
          ClientCode: data?.product.clientCode,
          ProductCode: data?.product.productCode
        }
      ]
    }

    const insureds = data.pets.map((pet, i) => ({
      riskNumber: String(i + 1),
      petName: pet.name,
      coverages: [
        ...pet.coverages,
        ...(pet.additionalCoverages?.map((ac) => ({
          coverageCode: ac.coverageCode,
          sumInsured: String(ac.rangeValue ? ac.rangeValue : ac.sumInsured)
        })) ?? [])
      ]
    }))

    return new PetsRaterPriceRequest({
      clientProducts: clientProducts,
      businessLine: data?.businessLine ?? 'MA01',
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.startDate),
      insureds,
      quotationNumber: data.product?.quotationNumber || undefined,
      quotationId: data.quotationId ?? undefined,
      isQuote,
      mediator
    })
  }
}
